<template>
  <div>
    <v-container fluid>
      <v-row dense>
        <v-col cols="2">
          <v-autocomplete v-model="year" :items="years" label="From July 1" outlined dense hide-details @change="refresh"/>
        </v-col>
        <v-col cols="2">
          <v-autocomplete v-model="groupBy" :items="['Date','Recipient','Product']" label="Group by" outlined dense hide-details @change="buildReport()"/>
        </v-col>
        <v-col class="text-right pr-2">
          <v-btn icon @click="printHtml('Ontario annual promitional distribution', report)"><v-icon>mdi-printer</v-icon></v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="mx-4 pa-4 overflow-y" height="calc(100vh - 180px)">
      <span v-html="report"/>
    </v-card>

  </div>
</template>

<script>
import {format} from 'date-fns'
import printHtml from '@/mixins/printHtml'

export default {
  name: 'ReportsOntarioPromotionalDistribution',
  mixins: [printHtml],
  data() {
    return {
      year: null,
      years: [],
      groupBy: 'Date',
      lines: [],
      report: ''
    }
  },
  async created() {
    this.$emit('name', 'Ontario Annual promotional distribution');

    const date = format(new Date(), 'yyyyMM');
    this.year = parseInt(date.substring(0, 4));
    if (date.substring(4) < '07')
      this.year--;
    for (let year = this.year; year >= 2019; year--)
      this.years.push(year);
    this.refresh();
  },

  methods: {
    async refresh() {
      this.loading = true;
      const results = await this.$apiCall(`query ReportsOntarioPromotionalDistribution($from:Date!,$to:Date!) {
                                             ontarioPromotionalDistribution(from:$from,to:$to) {
                                               date,recipientId,recipient,productId,product,retailPrice,bottles,litres
                                             }
                                            }`,
                                            {from:`${this.year}-07-01`,to:`${this.year+1}-06-30`});
      if (!results.error) {
        this.lines = results.data.ontarioPromotionalDistribution;
        this.buildReport();
      }
      this.loading = false;
    },

    buildReport() {
      const lines = [`<style>
                @page {size:landscape}
                .report-promotional-distribution {font-family: Roboto, sans-serif; width:100%;border-spacing:0;font-size:12px}
                .report-promotional-distribution th {height:36px;padding:0 16px;vertical-align:middle}
                .report-promotional-distribution .spacer {height:18px}
                .report-promotional-distribution td {height:36px;padding:0 16px;vertical-align:middle}
                .report-promotional-distribution .title {font-size:18px;text-transform:uppercase}
                .report-promotional-distribution .sup-title {font-weight:normal;font-size:22px}
                .report-promotional-distribution .sub-title {font-weight:normal;height:inherit;padding-bottom:20px;font-size:14px}
                .report-promotional-distribution .header th {border-bottom:1px solid #000;margin-bottom:20px}
                .report-promotional-distribution .text-left {text-align:left}
                .report-promotional-distribution .text-right {text-align:right}
                .report-promotional-distribution .text-center {text-align:center}
                .report-promotional-distribution .font-weight-bold {font-weight:bold}
                .report-promotional-distribution .indent {text-indent:20px}
                .report-promotional-distribution .total {border-top:1px solid #000}
              </style>
              <table class="report-promotional-distribution">
                <thead>
                  <tr>
                    <th colspan="5" class="sup-title">${this.$store.getters.company.name}</th>
                  </tr>
                  <tr>
                    <th colspan="5" class="title">Ontario promotional distribution</th>
                  </tr>
                  <tr>
                    <th colspan="5" class="sub-title">Year beginning ${this.date(this.year+'-07-01')}</th>
                  </tr>
                  <tr class="header">
                    <th width="25%" class="text-left">${this.groupBy==='Date'?'Recipient':'Date'}</th>
                    <th width="30%" class="text-left">${this.groupBy==='Product'?'Recipient':'Product'}</th>
                    <th width="15%" class="text-right">Bottles</th>
                    <th width="15%" class="text-right">Retail</th>
                    <th width="15%" class="text-right">Litres</th>
                  </tr>
                  </thead>
                  <tbody>`];

      let grandTotal = {prefix:'',bottles:0,retailPrice:0,litres:0};
      let total;
      if (this.groupBy == "Date") {
        this.lines.sort((a,b) => {
          if (a.date > b.date)
            return 1;
          if (a.date < b.date)
            return -1;
          return 0;
        })
        let date = '';
        this.lines.forEach(line => {
          if (line.date !== date) {
            if (date !== '')
              this.totalLine(lines, total);
            date = line.date;
            lines.push(`<tr>
                          <td class="font-weight-bold">${line.date}</td>
                          <td colspan="4"/>
                        </tr>`);
            total = {prefix:this.date(line.date),bottles:0,retailPrice:0,litres:0};
          }
          total.bottles += line.bottles;
          total.retailPrice += line.retailPrice;
          total.litres += line.litres;
          grandTotal.bottles += line.bottles;
          grandTotal.retailPrice += line.retailPrice;
          grandTotal.litres += line.litres;
          lines.push(`<tr>
                        <td class="indent">${line.recipient}</td>
                        <td>${line.product}</td>
                        <td class="text-right">${line.bottles}</td>
                        <td class="text-right">${this.currency(line.retailPrice)}</td>
                        <td class="text-right">${this.litres(line.litres)}</td>
                      </tr>`);
        });
      }
      else if (this.groupBy == "Recipient") {
        this.lines.sort((a,b) => {
          if (a.recipient > b.recipient)
            return 1;
          if (a.recipient < b.recipient)
            return -1;
          return 0;
        })
        let recipientId = '';
        this.lines.forEach(line => {
          if (line.recipientId !== recipientId) {
            if (recipientId !== '')
              this.totalLine(lines, total);
            recipientId = line.recipientId;
            lines.push(`<tr>
                          <td class="font-weight-bold">${line.recipient}</td>
                          <td colspan="4"/>
                        </tr>`);
            total = {prefix:line.recipient,bottles:0,retailPrice:0,litres:0};
          }
          total.bottles += line.bottles;
          total.retailPrice += line.retailPrice;
          total.litres += line.litres;
          grandTotal.bottles += line.bottles;
          grandTotal.retailPrice += line.retailPrice;
          grandTotal.litres += line.litres;
          lines.push(`<tr>
                        <td class="indent">${this.date(line.date)}</td>
                        <td>${line.product}</td>
                        <td class="text-right">${line.bottles}</td>
                        <td class="text-right">${this.currency(line.retailPrice)}</td>
                        <td class="text-right">${this.litres(line.litres)}</td>
                      </tr>`);
        });
      }
      else if (this.groupBy == "Product") {
        this.lines.sort((a,b) => {
          if (a.product > b.product)
            return 1;
          if (a.product < b.product)
            return -1;
          return 0;
        })
        let productId = '';
        this.lines.forEach(line => {
          if (line.productId !== productId) {
            if (productId !== '')
              this.totalLine(lines, total);
            productId = line.productId;
            lines.push(`<tr>
                          <td class="font-weight-bold">${line.product}</td>
                          <td colspan="4"/>
                        </tr>`);
            total = {prefix:line.product,bottles:0,retailPrice:0,litres:0};
          }
          total.bottles += line.bottles;
          total.retailPrice += line.retailPrice;
          total.litres += line.litres;
          grandTotal.bottles += line.bottles;
          grandTotal.retailPrice += line.retailPrice;
          grandTotal.litres += line.litres;
          lines.push(`<tr>
                        <td class="indent">${this.date(line.date)}</td>
                        <td>${line.recipient}</td>
                        <td class="text-right">${line.bottles}</td>
                        <td class="text-right">${this.currency(line.retailPrice)}</td>
                        <td class="text-right">${this.litres(line.litres)}</td>
                      </tr>`);
        });
      }
      if (total)
        this.totalLine(lines, total);
      this.totalLine(lines, grandTotal);

      lines.push(`</tbody></table>`);
      this.report = lines.join('');
    },
    totalLine(lines, total) {
      lines.push(`<tr>
                    <td>${total.prefix} TOTAL</td>
                    <td/>
                    <td class="text-right total">${total.bottles}</td>
                    <td class="text-right total">${this.currency(total.retailPrice)}</td>
                    <td class="text-right total">${this.litres(total.litres)}</td>
                  </tr>
                  <tr><td colspan="5" class="spacer"></tr>`);
    },
    litres(value) {
      return this.$number(value, 3);
    },
    currency(value) {
      return this.$currency(value);
    },
    date(value) {
      return this.$formatDate(value);
    }
  }
}
</script>